import React from 'react';
import { Tooltip, Tag, Table, Icon, Button } from 'antd';
import CustomAvatar from './customAvatar';
import { s3 } from '../utils';
import moment from 'moment';
import { navigate } from "@reach/router"
import { getCurrencySign } from '../utils/invoices';
import { flexCenterRight } from '../theme';

const { orderBy } = require('lodash');

const renderInvoice = (type) => {
  switch (type) {
    case 'client':
      return renderInvoiceForClient();
    case 'candidate':
      return renderInvoiceForCandidate();
    case 'contact':
      return renderInvoiceForContact();
    default:
      return null;
  }
}

const contactColumn = () => {
  const showContact = (invoice) => {
    const contactArr = [invoice.contact];
    if (invoice.additionalContact) {
      contactArr.push(invoice.additionalContact)
    }

    return(
      contactArr.map(i =>
        <span key={i.id} style={{cursor: 'pointer'}} onClick={() => {
          navigate(`/contacts/${i.id}`)
        }}>
          <CustomAvatar
            showTooltip={true}
            tooltipTitle={`${i.firstname} ${i.lastname}`}
            style={{
              marginLeft: "-15px",
              position: "relative",
              border: "1px solid #fff",
              overflow: "hidden",
            }}
            colourCode={i.firstname.charAt(0).toLowerCase()}
            char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
            charSize={12}
            src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.id}.jpeg`}
          />
        </span>)
    )
  }

  return [
    {
      title: <div style={{marginLeft: '-15px'}}>Contact</div>,
      width: '10%',
      key: 'contact',
      render: (invoice) => <>{showContact(invoice)}</>
    },
  ]
}

const genericColumn = () => {

  const showMoney = (invoice) => {
    if (invoice.paymentReceived) {
      return(
        <>
          <b><Tag color="#f50">{getCurrencySign(invoice.actualCurrency)}{(invoice.actualFee - invoice.actualRefund).toLocaleString()}</Tag></b>
        </>
      )

    } else {
      return(
        <>
          {getCurrencySign(invoice.currency)}{invoice.fee}
        </>
      )
    }
  }

  const renderInvoiceStatus = (invoice) => {
    if (invoice.isActive) {

      if (invoice.paymentReceived) {

        if (invoice.actualRefund > 0) {

          if (invoice.actualFee - invoice.actualRefund > 0) {
            return(
              <Tag color="#b7eb8f">Partial Payment Received</Tag>
            )
          } else {
            return(
              <Tag color="#ccc">Full Refund</Tag>
            )
          }
        } else {
          return(
            <Tag color="#73d13d">Full Payment Received</Tag>
          )
        }
      } else {
        if (invoice.sendInvoice) {
          return(
            <Tag color="#FB607F">Waiting Payment</Tag>        
          )
        }
        if (moment() < moment(invoice.onBoard)) {
          return(
            <Tag color="#7CB9E8">Waiting Candidate On Board</Tag>
          )
        }
        if (moment() > moment(invoice.onBoard) &&
            moment() < moment(invoice.onBoard).add(1, 'days')) {
          return(
            <Tag color="#FF8C00">Waiting Send Invoice</Tag>        
          )
        }
        if (!invoice.sendInvoice && 
            moment() > moment(invoice.onBoard).add(1, 'days')) {
          return(
            <Tag color="#FF8C00">Waiting Send Invoice</Tag>
          )
        }
      }
    } else {
      return(
        <Tag color="#ccc">Withdraw</Tag>
      )
    }
  }

  return [
    {
      title: 'Status',
      width: '10%',
      key: 'status',
      render: (invoice) => <>
        {renderInvoiceStatus(invoice)}
      </>
    },
    {
      title: 'On Board',
      width: '12%',
      key: 'onBoard',
      render: (invoice) => <>
        {moment(invoice.onBoard).format('YYYY-MM-DD')}
      </>
    },
    {
      title: '',
      width: '8%',
      key: 'money',
      render: (invoice) => <>{showMoney(invoice)}</>
    },
    {
      title: '',
      width: '5%',
      key: 'control',
      render: (invoice) => <div style={flexCenterRight}>
        <Tooltip title="Details">
          <Button size="small" key="details" onClick={() => {
            navigate(`/invoices/${invoice.id}`);
          }}>
            <Icon type="plus" />
          </Button>
        </Tooltip>
      </div>
    },
  ]
}

const renderInvoiceForCandidate = () => {
  const client = {
    title: 'Client',
    width: '20%',
    key: 'client',
    render: (invoice) => <div style={{cursor: "pointer"}} onClick={() => {
      navigate(`/clients/${invoice.client.id}`)
    }}>
      <CustomAvatar
        colourCode={invoice.client.name.charAt(0).toLowerCase()}
        char={`${invoice.client.name.charAt(0).toUpperCase()}`}
        charSize={13}
        size={26}
        src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/client/${invoice.client.id}.jpeg`}
      />
      &nbsp;{invoice.client.name}
    </div>
  }

  return [
    ...[client],
    ...contactColumn(),
    ...genericColumn(),
  ]
}

const renderInvoiceForClient = () => {

  const candidate = {
    title: 'Candidate',
    width: '20%',
    key: 'candidate',
    render: (invoice) => <div style={{cursor: "pointer"}} onClick={() => {
      navigate(`/candidates/${invoice.candidate.id}`)
    }}>
      <CustomAvatar
        colourCode={invoice.candidate.firstname.charAt(0).toLowerCase()}
        char={`${invoice.candidate.firstname.charAt(0).toUpperCase()}${invoice.candidate.lastname.charAt(0).toUpperCase()}`}
        charSize={13}
        size={26}
        src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${invoice.candidate.id}.jpeg`}
      />
      &nbsp;{invoice.candidate.firstname} {invoice.candidate.lastname}
    </div>
  }

  return [
    ...[candidate],
    ...contactColumn(),
    ...genericColumn(),
  ]
}

const renderInvoiceForContact = () => {

  const clientCandidate = {
    title: 'Client / Candidate',
    width: '20%',
    key: 'clientCandidate',
    render: (invoice) => <div>
      <Tooltip title={`Client: ${invoice.client.name}`}>
        <span style={{cursor: "pointer"}} onClick={() => {
          navigate(`/clients/${invoice.client.id}`)
        }}>
          <CustomAvatar
            colourCode={invoice.client.name.charAt(0).toLowerCase()}
            char={`${invoice.client.name.charAt(0).toUpperCase()}`}
            charSize={13}
            size={26}
            src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/client/${invoice.client.id}.jpeg`}
          />
        </span>
      </Tooltip>
      &nbsp;&nbsp;
      <span style={{cursor: "pointer"}} onClick={() => {
        navigate(`/candidates/${invoice.candidate.id}`)
      }}>
        <CustomAvatar
          colourCode={invoice.candidate.firstname.charAt(0).toLowerCase()}
          char={`${invoice.candidate.firstname.charAt(0).toUpperCase()}${invoice.candidate.lastname.charAt(0).toUpperCase()}`}
          charSize={13}
          size={26}
          src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${invoice.candidate.id}.jpeg`}
        />
      &nbsp;
      {invoice.candidate.firstname} {invoice.candidate.lastname}
      </span>
    </div>
  }

  return [
    ...[clientCandidate],
    ...genericColumn(),
  ]
}

function InvoicesList({ invoices, type }) {
  return (
    <Table
      pagination={false}
      columns={renderInvoice(type)}
      dataSource={orderBy(invoices, 'onBoard', 'desc')}
      rowKey="id"
    />
  );
}

export default InvoicesList;
